import { render } from "./NoteAdmin.vue?vue&type=template&id=9f256292&scoped=true"
import script from "./NoteAdmin.vue?vue&type=script&lang=js"
export * from "./NoteAdmin.vue?vue&type=script&lang=js"

import "./NoteAdmin.vue?vue&type=style&index=0&id=9f256292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f256292"]])

export default __exports__